import React from 'react'
import {Link} from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { scrollToTop } from '../header';
import ab1 from '../../images/about/temple3.webp'
import './style.css'

const About = (props) => {
    const { t } = useTranslation();
    
    return(
        <div className="wpo-about-area section-padding optimize-visibility">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-md-12 col-sm-12">
                        <div className="wpo-about-img">
                            <img src={ab1} alt=""/>
                        </div>
                    </div>
                    <div className="col-lg-5 col-md-12 colsm-12">
                        <div className="wpo-about-text">
                            <div className="wpo-section-title">
                                <span></span>
                                <h2>{t('best_deals')} <br/> {t('for_your_tickets')}</h2>
                            </div>
                            <p>{t('explore_thailand')}</p>
                            <div className="btns">
                                <Link onClick={() => scrollToTop()} to="/about" className="theme-btn-s2">{t('more_about_us')}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About;